exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-calculator-js": () => import("./../../../src/pages/calculator.js" /* webpackChunkName: "component---src-pages-calculator-js" */),
  "component---src-pages-daily-js": () => import("./../../../src/pages/daily.js" /* webpackChunkName: "component---src-pages-daily-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-character-profile-js": () => import("./../../../src/templates/characterProfile.js" /* webpackChunkName: "component---src-templates-character-profile-js" */)
}

